import { DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform  } from '@angular/core';
import { isNumber } from 'util';
@Pipe({
  name: 'localizedDecimal'
})
export class LocalizedDecimalPipe implements PipeTransform {
  constructor(
      private translateService: TranslateService,
      private decimalPipe: DecimalPipe
  ) {}
  transform (input: number, decimals = 2): any {
    const currentLang = this.translateService.currentLang;
    if (!isNumber(input)) {
      return input;
    }
    return this.decimalPipe.transform(input, `1.${ decimals }-${ decimals }`, currentLang);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/pipes/localized-decimal.pipe.ts